import { render } from "./OffcanvasHeader.vue?vue&type=template&id=2c5d9fca"
import script from "./OffcanvasHeader.vue?vue&type=script&lang=js"
export * from "./OffcanvasHeader.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__